import { CostWaterfall } from '@/features/quotes/components/cost-waterfall';
import type { CostWaterfallStep } from '@/features/quotes/types/quote.types';
import { DEMO_SCENARIO } from '../data/tutorial-data';

const WATERFALL_STEPS: CostWaterfallStep[] = [
  {
    label: 'Total Licencias (50 × $19.80)',
    amount: DEMO_SCENARIO.calculated.TOTAL_LICENCIAS,
    percentage:
      (DEMO_SCENARIO.calculated.TOTAL_LICENCIAS / DEMO_SCENARIO.calculated.PRECIO_FINAL_TOTAL) *
      100,
    color: 'bg-blue-500',
  },
  {
    label: 'Implementacion',
    amount: DEMO_SCENARIO.inputs.COSTO_IMPLEMENTACION,
    percentage:
      (DEMO_SCENARIO.inputs.COSTO_IMPLEMENTACION / DEMO_SCENARIO.calculated.PRECIO_FINAL_TOTAL) *
      100,
    color: 'bg-indigo-500',
  },
  {
    label: 'Soporte Anual',
    amount: DEMO_SCENARIO.inputs.COSTO_SOPORTE_ANUAL,
    percentage:
      (DEMO_SCENARIO.inputs.COSTO_SOPORTE_ANUAL / DEMO_SCENARIO.calculated.PRECIO_FINAL_TOTAL) *
      100,
    color: 'bg-violet-500',
  },
  {
    label: 'Utilidad (25%)',
    amount: DEMO_SCENARIO.calculated.UTILIDAD,
    percentage:
      (DEMO_SCENARIO.calculated.UTILIDAD / DEMO_SCENARIO.calculated.PRECIO_FINAL_TOTAL) * 100,
    color: 'bg-green-500',
  },
  {
    label: 'Precio Final Total',
    amount: DEMO_SCENARIO.calculated.PRECIO_FINAL_TOTAL,
    isCumulative: true,
  },
];

export function WaterfallDemo() {
  return (
    <div className="space-y-3">
      <p className="text-sm text-muted-foreground">
        Asi se desglosa el precio de la cotizacion de Maria para Banco Nacional:
      </p>
      <CostWaterfall steps={WATERFALL_STEPS} currencySymbol="$" />
    </div>
  );
}
